/**
 * An Asset is any fungible financial instrument, including Ether, all ERC20 tokens, and NFTs
 */
export class Asset {
    /**
     * Constructs an instance of the `Asset`.
     * @param symbol symbol of the asset
     * @param name of the asset
     * @param coinGeckoId CoinGecko ID for price lookups
     * @param isStablecoin whether the asset is a stablecoin
     */
    constructor(symbol, name, coinGeckoId, isStablecoin) {
        this.symbol = symbol;
        this.name = name;
        this.coinGeckoId = coinGeckoId;
        this.isStablecoin = isStablecoin;
    }
    setCoinGeckoId(coinGeckoId) {
        this.coinGeckoId = coinGeckoId;
    }
    /**
     * Returns whether this asset is functionally equivalent to the other asset
     * @param other the other asset
     */
    equals(other) {
        if (this === other)
            return true;
        return this.symbol === other.symbol && this.name === other.name;
    }
    /**
     * Converts the asset to a model representation for serialization
     */
    toAssetModel() {
        return { symbol: this.symbol, name: this.name };
    }
    static toAsset(asset) {
        if (!asset) {
            return undefined;
        }
        const { symbol, name } = asset;
        return new Asset(symbol, name);
    }
    id() {
        return `${this.name}:${this.symbol}`;
    }
}
